/**
 * Created by Christof Sander on 16.01.2017.
 */

var uuid = require('uuid');
var uploadRoute = '/upload/preparedImage';

module.exports = {
	config: {
		mode: 				'image',
		deletableFiles: 	false,
		secureRoute: uploadRoute,
		pluploaderConfig: {
			maxNrOfFiles:			-1, // max nr of files in upload queue
			blockQueueDuringUpload: false, // block button during upload

			runtimes:               'html5,flash,silverlight,html4',
			// browse_button:          'upload', // will be set by attach-trigger
			container:              undefined, // ... or DOM Element itself
			url:                    uploadRoute,
			chunk_size:             '200kb',
			// unique_names:           true,     //-> we want the original filename -> don't use it
			max_retries:            3,
			flash_swf_url:          '/webpack/js/Moxie.swf',
			silverlight_xap_url:    '/webpack/js/Moxie.xap',

			headers: {},

			multipart_params: {
				fileID: 'replaceThis'
			},

			filters: {
				// prevent_duplicates : true,
				max_file_size : '10mb',
				mime_types: [
					{title : "Image files", extensions : "jpg,jpeg,gif,png,svg"}
				]
			},

			init: {
				PostInit: function(up){},

				FilesAdded: function(up, files) {
					var $progress = up.component.$.find('.progress');
					$progress.addClass('inProgress');

					if(up.settings.maxNrOfFiles > 0 && up.files.length > up.settings.maxNrOfFiles){
						up.splice(0, up.files.length - up.settings.maxNrOfFiles);
					}

					up.start();

					// TODO: block add queue during upload
					// NOTE: up.settings.blockQueueDuringUpload
				},

				BeforeUpload: function(up, file){
					// set file id for the actual file
					up.settings.multipart_params.fileID = uuid.v4();
					up.settings.multipart_params.categories = JSON.stringify(up.component.model.mediaCategories || {});
				},

				UploadProgress: function(up, file) {
					var $progress = up.component.$.find('.progress');
					var $progressBar = $progress.find('.background');
					var $progressContent = $progress.find('.content');
					$progressBar.width(up.total.percent + '%');
					$progressContent.html(up.total.percent + '%');
				},

				FileUploaded: function(up, file, result){
					if(result.status == 200 && result.response){
						result.response = JSON.parse(result.response);

						if(typeof(up.component.fileUploaded) === 'function'){
							up.component.fileUploaded(result.response);
						}
					}
				},

				UploadComplete: function(up, files){
					var $progress = up.component.$.find('.progress');
					var $progressBar = $progress.find('.background');
					$progress.removeClass('inProgress');
					$progressBar.width('0');

					if(typeof(up.component.uploadComplete) === 'function'){
						up.component.uploadComplete(files);
					}
				},

				Error: function(up, error) {
					var errorCode;
					switch(error.code){
						case plupload.HTTP_ERROR:                    errorCode = 'http'; break;
						case plupload.IO_ERROR:                      errorCode = 'io'; break;
						case plupload.SECURITY_ERROR:                errorCode = 'security'; break;
						case plupload.INIT_ERROR:                    errorCode = 'init'; break;
						case plupload.FILE_SIZE_ERROR:               errorCode = 'file-size'; break;
						case plupload.FILE_EXTENSION_ERROR:          errorCode = 'file-extension'; break;
						case plupload.FILE_DUPLICATE_ERROR:          errorCode = 'file-duplicate'; break;
						case plupload.IMAGE_FORMAT_ERROR:            errorCode = 'image-format'; break;
						case plupload.MEMORY_ERROR:                  errorCode = 'memory'; break;
						case plupload.IMAGE_DIMENSIONS_ERROR:        errorCode = 'image-dimensions'; break;
						case plupload.GENERIC_ERROR:
						default:                            errorCode = 'generic'; break;
					}

					up.component.performAction(up.component.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:pluploader.' + errorCode
						}
					}));
				}
			}
		}
	},
	events: {
		controlsClick: {
			type: 'click',
			selector: '.controls i',
			action: function(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var $target, $element, type, mediaID, mediaIndex;
				if(
					($target = $(event.target)).length > 0 &&
					($element = $target.closest('.element')).length > 0 &&
					(type = $target.data('type')) === 'delete' &&
					(mediaIndex = $element.data('mediaIndex')) !== undefined &&
					(mediaID = $element.data('mediaId'))
				){
					event.data.component.deleteElement(mediaIndex, mediaID);
				}
			}
		}
	},

	model: {
		errors: []
	},

	methods: {
		deleteElement: function(mediaIndex, mediaID){
			// NOTE: this function should be overwritten if needed
		}
	},

	hooks: {
		attach: function($element, options){
			if(!this.config.disabled){
				this.config.pluploaderConfig.headers['fec_secure_route'] = this.config.secureRoute;
				this.config.pluploaderConfig.container = $element.find('.uploads')[0];
				this.config.pluploaderConfig.browse_button = 'upload_' + (this.config.context || '~') + '_' + this.config.mode;

				this.model._uploader = new plupload.Uploader(this.config.pluploaderConfig);
				this.model._uploader.init();
				this.model._uploader.component = this;
			}
		}
	}
};